module.exports = {"pathContext":{"title":"Searching for a Lost Odessa and a Deaf Childhood","createdAt":"19 hours ago","by":"antigizmo","comments":[]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/comment-17768173.json
// module id = 886
// module chunks = 65309315480778